export { default, FailSvg } from './FailSvg';